<template>
  <ul class="mt-3">
    <single-node v-for="(category, index) in categories" :node="category" :key="index" @edit="$emit('edit', $event)" @remove="$emit('remove', $event)"></single-node>
  </ul>
</template>

<script>
import singleNode from "./singleNode";

export default {
  props: {
    categories: Array,
  },
  components: {
    singleNode
  }
};
</script>

<style>
  ul {
    list-style: none;
    padding-left: 0;
  }
</style>